//import {ISchemaLine} from "./interfaces";
import * as moment from "moment";
import {ISchemaLine} from "@retail-data-factory/rdf-angular-types-api";


export const mockSchemaList: Array<ISchemaLine> = [
  {
    current: {
      id: '13',
      partyId: '1000',
      schemaId: '1',
      isActual: true,
      name: 'Текущая схема атрибутов товаров',
      type: 'nomenclature',
      version: '3',
      dateCreate: new Date(),
      dateUpdate: moment('20200518','YYYYMMDD').toDate(),
      elementsCount: 20,
      pages: [
        {
          id: '0',
          name: 'Лист 1',
          groups: [
            {
              id: '1',
              name: 'Общая информация об артикуле',
              elements: [
                {
                  id: '1',
                  code: '1',
                  name: 'Код Ашан',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '2',
                  code: '2',
                  name: 'Наименование артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '3',
                  code: '3',
                  name: 'Внутренний код поставщика',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 13-15 цифр',
                  public: false
                },
                {
                  id: '4',
                  code: '4',
                  name: 'Штрихкод',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                  public: false
                },
                {
                  id: '5',
                  code: '5',
                  name: 'Дополнительные штрихкоды',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                  public: false
                },
                {
                  id: '6',
                  code: '6',
                  name: 'Категория',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                  public: false
                },
                {
                  id: '7',
                  code: '7',
                  name: 'Семья',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '8',
                  code: '8',
                  name: 'Базовая скидка',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '9',
                  code: '9',
                  name: 'Ставка НДС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '10',
                  code: '10',
                  name: 'Количество штук в коробе РСВ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '11',
                  code: '11',
                  name: 'ITF-14 / Штрихкод',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '12',
                  code: '12',
                  name: 'Количество штук в групповой упаковке суб-РСВ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '13',
                  code: '13',
                  name: 'ОКПД',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '14',
                  code: '14',
                  name: 'Страна происхождения',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '15',
                  code: '15',
                  name: 'Единица закупки',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '16',
                  code: '16',
                  name: 'Единица продажи',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '17',
                  code: '17',
                  name: 'Характеристика товара',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '18',
                  code: '18',
                  name: 'Тип товара',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '19',
                  code: '19',
                  name: 'Ашан прод',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '20',
                  code: '20',
                  name: 'Код проекта',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '21',
                  code: '21',
                  name: 'Категория товара (cours du jour)',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '22',
                  code: '22',
                  name: 'Статус артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '23',
                  code: '23',
                  name: 'Код ассортимента',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '2',
              name: 'Размер товара в метрах',
              elements: [
                {
                  id: '24',
                  code: '24',
                  name: 'Высота',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '25',
                  code: '25',
                  name: 'Ширина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '26',
                  code: '26',
                  name: 'Глубина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '3',
              name: 'Хранение',
              elements: [
                {
                  id: '27',
                  code: '27',
                  name: 'Срок годности в днях',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '28',
                  code: '28',
                  name: 'Температура хранения мин',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '29',
                  code: '29',
                  name: 'Температура хранения макс',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '4',
              name: 'Спиртосодержание',
              elements: [
                {
                  id: '30',
                  code: '30',
                  name: 'Спиртосодержание',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '31',
                  code: '31',
                  name: 'Процент содержания спирта',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '32',
                  code: '32',
                  name: 'Код ВАП',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '33',
                  code: '33',
                  name: 'Объем единицы измерения в литрах',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '34',
                  code: '34',
                  name: 'Мин. цена продажи табака',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '35',
                  code: '35',
                  name: 'Макс. цена продажи табака',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '36',
                  code: '36',
                  name: 'МРЦ алкогольной продукции',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '37',
                  code: '37',
                  name: 'Код ЕГАИС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '5',
              name: 'Коллекция',
              elements: [
                {
                  id: '38',
                  code: '38',
                  name: 'Номер коллекции',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '39',
                  code: '39',
                  name: 'Активность 1 с',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '40',
                  code: '40',
                  name: 'по',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '41',
                  code: '41',
                  name: 'Активность 2 с',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '42',
                  code: '42',
                  name: 'по',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '43',
                  code: '43',
                  name: 'Активность 3 с',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '44',
                  code: '44',
                  name: 'по',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '45',
                  code: '45',
                  name: 'Активность 4 с',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '46',
                  code: '46',
                  name: 'по',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '6',
              name: 'Наименование на ценнике',
              elements: [
                {
                  id: '47',
                  code: '47',
                  name: 'Параметр 1',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '48',
                  code: '48',
                  name: 'Параметр 2',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '49',
                  code: '49',
                  name: 'Параметр 3',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '50',
                  code: '50',
                  name: 'Параметр 4',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '51',
                  code: '51',
                  name: 'Параметр 5',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '52',
                  code: '52',
                  name: 'Параметр 6',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '53',
                  code: '53',
                  name: 'Параметр 7',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '54',
                  code: '54',
                  name: 'Параметр 8',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '55',
                  code: '55',
                  name: 'Параметр 9',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '56',
                  code: '56',
                  name: 'Параметр 10',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '57',
                  code: '57',
                  name: 'Параметр 11',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '58',
                  code: '58',
                  name: 'Параметр 12',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '59',
                  code: '59',
                  name: 'Параметр 13',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '60',
                  code: '60',
                  name: 'Параметр 14',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '61',
                  code: '61',
                  name: 'Параметр 15',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '7',
              name: 'Другие атрибуты',
              elements: [
                {
                  id: '62',
                  code: '62',
                  name: 'Стоимость ввода артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '63',
                  code: '63',
                  name: 'Код закрываемого артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '64',
                  code: '64',
                  name: 'Наименование закрываемого артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '65',
                  code: '65',
                  name: 'Комментарий',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '66',
                  code: '66',
                  name: 'Лот заказываемый',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '67',
                  code: '67',
                  name: 'Штука продаваемый',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '68',
                  code: '68',
                  name: 'Кол-во штук в лоте',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            }

          ],

        }
      ]
    },
    versions: [
      {
        id: '12',
        partyId: '1000',
        schemaId: '1',
        isActual: false,
        name: 'Схема атрибутов 17-05',
        type: 'nomenclature',
        version: '2',
        dateCreate: new Date(),
        dateUpdate:  moment('20200517','YYYYMMDD').toDate(),
        elementsCount: 15,
        pages: [
          {
            id: '0',
            name: 'Лист 1',
            groups: [
              {
                id: '1',
                name: 'Юридическое лицо',
                elements: [
                  {
                    id: '1',
                    code: '1',
                    name: 'Название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '2',
                    code: '2',
                    name: 'Краткое название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '3',
                    code: '3',
                    name: 'ОГРН/ОГРНИП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13-15 цифр',
                    public: false
                  },
                  {
                    id: '4',
                    code: '4',
                    name: 'ИНН',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '5',
                    code: '5',
                    name: 'КПП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '6',
                    code: '6',
                    name: 'Юр. адрес',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  }
                ]
              },
              {
                id: '2',
                name: 'Идентификаторы',
                elements: [
                  {
                    id: '7',
                    code: '7',
                    name: 'Внутрениий номер магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Маска: "Магазин №…" если применимо',
                    public: false
                  },
                  {
                    id: '8',
                    code: '8',
                    name: 'Внутреннее имя магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '9',
                    code: '9',
                    name: 'GLN магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '10',
                    code: '10',
                    name: 'GLN РЦ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '11',
                    code: '11',
                    name: 'GUID (Меркурий)',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '12',
                    code: '12',
                    name: 'ЕГАИС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, до 9-11 цифр',
                    public: false
                  },
                  {
                    id: '13',
                    code: '13',
                    name: 'Логистический филиал',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '14',
                    code: '14',
                    name: 'Единый сквозной идентификатор',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                ]
              },
              {
                id: '3',
                name: 'География',
                elements: [
                  {
                    id: '15',
                    code: '15',
                    name: 'Регион',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Выбор из классификатора ФИАС',
                    public: false
                  },
                  {
                    id: '16',
                    code: '16',
                    name: 'Населенный пункт',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Выбор из классификатора ФИАС',
                    public: false
                  },
                  {
                    id: '17',
                    code: '17',
                    name: 'Адрес местонахождения',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  },
                  {
                    id: '18',
                    code: '18',
                    name: 'Широта',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовое поле с маской ***,******',
                    public: false
                  },
                  {
                    id: '19',
                    code: '19',
                    name: 'Долгота',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовое поле с маской ***,******',
                    public: false
                  },
                  {
                    id: '20',
                    code: '20',
                    name: 'География ритейлера',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '21',
                    code: '21',
                    name: 'Код ФИАС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '22',
                    code: '22',
                    name: 'Уровень по ФИАС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  }
                ]
              },
              {
                id: '4',
                name: 'Торговые параметры',
                elements: [
                  {
                    id: '23',
                    code: '23',
                    name: 'Формат по каналу',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '24',
                    code: '24',
                    name: 'Формат по площади',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '25',
                    code: '25',
                    name: 'Торговая площадь',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '26',
                    code: '26',
                    name: 'Трафик',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '27',
                    code: '27',
                    name: 'Режим работы',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '28',
                    code: '28',
                    name: 'Список представленных категорий',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '29',
                    code: '29',
                    name: 'Длина полок в каждой категории',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '30',
                    code: '30',
                    name: 'Планограмма выкладки',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '31',
                    code: '31',
                    name: 'Ассортиментная емкость',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '32',
                    code: '32',
                    name: 'Количество касс',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  }
                ]
              }
            ],

          }
        ]
      },
      {
        id: '11',
        partyId: '1000',
        schemaId: '1',
        isActual: false,
        name: 'Схема атрибутов 14-05',
        type: 'nomenclature',
        version: '1',
        dateCreate: new Date(),
        dateUpdate:  moment('20200514','YYYYMMDD').toDate(),
        elementsCount: 10,
        pages: [
          {
            id: '0',
            name: 'Лист 1',
            groups: [
              {
                id: '1',
                name: 'Юридическое лицо',
                elements: [
                  {
                    id: '1',
                    code: '1',
                    name: 'Название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '2',
                    code: '2',
                    name: 'Краткое название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '3',
                    code: '3',
                    name: 'ОГРН/ОГРНИП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13-15 цифр',
                    public: false
                  },
                  {
                    id: '4',
                    code: '4',
                    name: 'ИНН',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '5',
                    code: '5',
                    name: 'КПП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '6',
                    code: '6',
                    name: 'Юр. адрес',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  }
                ]
              },
              {
                id: '2',
                name: 'Идентификаторы',
                elements: [
                  {
                    id: '7',
                    code: '7',
                    name: 'Внутрениий номер магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Маска: "Магазин №…" если применимо',
                    public: false
                  },
                  {
                    id: '8',
                    code: '8',
                    name: 'Внутреннее имя магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '9',
                    code: '9',
                    name: 'GLN магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '10',
                    code: '10',
                    name: 'GLN РЦ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '11',
                    code: '11',
                    name: 'GUID (Меркурий)',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '12',
                    code: '12',
                    name: 'ЕГАИС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, до 9-11 цифр',
                    public: false
                  },
                  {
                    id: '13',
                    code: '13',
                    name: 'Логистический филиал',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '14',
                    code: '14',
                    name: 'Единый сквозной идентификатор',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                ]
              }
            ],
          }
        ]
      }
    ]
  },
  {
    current: {
      id: '16',
      partyId: '1002',
      schemaId: '1',
      isActual: true,
      name: 'Текущая схема атрибутов сайтов',
      type: 'nomenclature',
      version: '3',
      dateCreate: new Date(),
      dateUpdate: moment('20200518','YYYYMMDD').toDate(),
      elementsCount: 20,
      pages: [
        {
          id: '0',
          name: 'Лист 1',
          groups: [
            {
              id: '1',
              name: 'Юридическое лицо',
              elements: [
                {
                  id: '1',
                  code: '1',
                  name: 'Название ЮЛ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '2',
                  code: '2',
                  name: 'Краткое название ЮЛ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '3',
                  code: '3',
                  name: 'ОГРН/ОГРНИП',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 13-15 цифр',
                  public: false
                },
                {
                  id: '4',
                  code: '4',
                  name: 'ИНН',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                  public: false
                },
                {
                  id: '5',
                  code: '5',
                  name: 'КПП',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                  public: false
                },
                {
                  id: '6',
                  code: '6',
                  name: 'Юр. адрес',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                  public: false
                }
              ]
            },
            {
              id: '2',
              name: 'Идентификаторы',
              elements: [
                {
                  id: '7',
                  code: '7',
                  name: 'Внутрениий номер магазина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Маска: "Магазин №…" если применимо',
                  public: false
                },
                {
                  id: '8',
                  code: '8',
                  name: 'Внутреннее имя магазина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле',
                  public: false
                },
                {
                  id: '9',
                  code: '9',
                  name: 'GLN магазина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 13 цифр',
                  public: false
                },
                {
                  id: '10',
                  code: '10',
                  name: 'GLN РЦ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 13 цифр',
                  public: false
                },
                {
                  id: '11',
                  code: '11',
                  name: 'GUID (Меркурий)',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '12',
                  code: '12',
                  name: 'ЕГАИС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, до 9-11 цифр',
                  public: false
                },
                {
                  id: '13',
                  code: '13',
                  name: 'Логистический филиал',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '14',
                  code: '14',
                  name: 'Единый сквозной идентификатор',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
              ]
            },
            {
              id: '3',
              name: 'География',
              elements: [
                {
                  id: '15',
                  code: '15',
                  name: 'Регион',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Выбор из классификатора ФИАС',
                  public: false
                },
                {
                  id: '16',
                  code: '16',
                  name: 'Населенный пункт',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Выбор из классификатора ФИАС',
                  public: false
                },
                {
                  id: '17',
                  code: '17',
                  name: 'Адрес местонахождения',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                  public: false
                },
                {
                  id: '18',
                  code: '18',
                  name: 'Широта',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовое поле с маской ***,******',
                  public: false
                },
                {
                  id: '19',
                  code: '19',
                  name: 'Долгота',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовое поле с маской ***,******',
                  public: false
                },
                {
                  id: '20',
                  code: '20',
                  name: 'География ритейлера',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '21',
                  code: '21',
                  name: 'Код ФИАС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле',
                  public: false
                },
                {
                  id: '22',
                  code: '22',
                  name: 'Уровень по ФИАС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            },
            {
              id: '4',
              name: 'Торговые параметры',
              elements: [
                {
                  id: '23',
                  code: '23',
                  name: 'Формат по каналу',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '24',
                  code: '24',
                  name: 'Формат по площади',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '25',
                  code: '25',
                  name: 'Торговая площадь',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '26',
                  code: '26',
                  name: 'Трафик',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '27',
                  code: '27',
                  name: 'Режим работы',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '28',
                  code: '28',
                  name: 'Список представленных категорий',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '29',
                  code: '29',
                  name: 'Длина полок в каждой категории',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '30',
                  code: '30',
                  name: 'Планограмма выкладки',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '31',
                  code: '31',
                  name: 'Ассортиментная емкость',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '32',
                  code: '32',
                  name: 'Количество касс',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            },
            {
              id: '5',
              name: 'Статус',
              elements: [
                {
                  id: '33',
                  code: '33',
                  name: 'Текущий статус',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '34',
                  code: '34',
                  name: 'Дата открытия',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '35',
                  code: '35',
                  name: 'Дата открытия заказов',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '36',
                  code: '36',
                  name: 'Дата закрытия',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '37',
                  code: '37',
                  name: 'Расписание реконструкций',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            },
            {
              id: '6',
              name: 'Контактные данные',
              elements: [
                {
                  id: '38',
                  code: '38',
                  name: 'Имя директора',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '39',
                  code: '39',
                  name: 'Телефон',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '40',
                  code: '40',
                  name: 'e-mail',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            },
            {
              id: '7',
              name: 'Логистические параметры',
              elements: [
                {
                  id: '42',
                  code: '42',
                  name: 'Возможность совмещения несколько ттн в одном авто (РЦ)',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '43',
                  code: '43',
                  name: 'Время обслуживания для выгрузки в секундах',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '44',
                  code: '44',
                  name: 'Время обслуживания для приемки в секундах',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '45',
                  code: '45',
                  name: 'Высота рампы на РЦ, м',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '46',
                  code: '46',
                  name: 'Допустимый свес продукции с поддона, см',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '47',
                  code: '47',
                  name: 'Каждая партия на отдельном поддоне',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '48',
                  code: '48',
                  name: 'Каждая партия отдельным слоем на поддоне',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '49',
                  code: '49',
                  name: 'Каждая партия отдельным столбиком на поддоне',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '50',
                  code: '50',
                  name: 'Каждый SKU отдельным слоем',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '51',
                  code: '51',
                  name: 'Каждый SKU отдельным столбиком',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '52',
                  code: '52',
                  name: 'Максимальная высота поддона, м',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '53',
                  code: '53',
                  name: 'Максимальный вес поддона, кг',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '54',
                  code: '54',
                  name: 'Необходимость заказа пропуска в закрытые города',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '55',
                  code: '55',
                  name: 'Необходимость заказа пропуска на движение грузовых авто',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '56',
                  code: '56',
                  name: 'Необходимость упаковочного / информационного листа',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '57',
                  code: '57',
                  name: 'Радиус доставки',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '58',
                  code: '58',
                  name: 'Требования к внешнему виду водителя - обувь',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '59',
                  code: '59',
                  name: 'Требования к внешнему виду водителя - одежда',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '60',
                  code: '60',
                  name: 'Требования к внешнему виду водителя - санитарная книжка',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '61',
                  code: '61',
                  name: 'Требования к поддонам - американские поддоны',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '62',
                  code: '62',
                  name: 'Требования к поддонам - синие поддоны',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '63',
                  code: '63',
                  name: 'Требования к транспорту - наличие гидролифта',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '64',
                  code: '64',
                  name: 'Требования к транспорту - наличие пневподвеса',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            }

          ],

        }
      ]
    },
    versions: [
      {
        id: '15',
        partyId: '1002',
        schemaId: '1',
        isActual: false,
        name: 'Схема атрибутов 17-05',
        type: 'nomenclature',
        version: '2',
        dateCreate: new Date(),
        dateUpdate:  moment('20200517','YYYYMMDD').toDate(),
        elementsCount: 15,
        pages: [
          {
            id: '0',
            name: 'Лист 1',
            groups: [
              {
                id: '1',
                name: 'Юридическое лицо',
                elements: [
                  {
                    id: '1',
                    code: '1',
                    name: 'Название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '2',
                    code: '2',
                    name: 'Краткое название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '3',
                    code: '3',
                    name: 'ОГРН/ОГРНИП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13-15 цифр',
                    public: false
                  },
                  {
                    id: '4',
                    code: '4',
                    name: 'ИНН',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '5',
                    code: '5',
                    name: 'КПП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '6',
                    code: '6',
                    name: 'Юр. адрес',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  }
                ]
              },
              {
                id: '2',
                name: 'Идентификаторы',
                elements: [
                  {
                    id: '7',
                    code: '7',
                    name: 'Внутрениий номер магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Маска: "Магазин №…" если применимо',
                    public: false
                  },
                  {
                    id: '8',
                    code: '8',
                    name: 'Внутреннее имя магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '9',
                    code: '9',
                    name: 'GLN магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '10',
                    code: '10',
                    name: 'GLN РЦ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '11',
                    code: '11',
                    name: 'GUID (Меркурий)',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '12',
                    code: '12',
                    name: 'ЕГАИС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, до 9-11 цифр',
                    public: false
                  },
                  {
                    id: '13',
                    code: '13',
                    name: 'Логистический филиал',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '14',
                    code: '14',
                    name: 'Единый сквозной идентификатор',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                ]
              },
              {
                id: '3',
                name: 'География',
                elements: [
                  {
                    id: '15',
                    code: '15',
                    name: 'Регион',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Выбор из классификатора ФИАС',
                    public: false
                  },
                  {
                    id: '16',
                    code: '16',
                    name: 'Населенный пункт',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Выбор из классификатора ФИАС',
                    public: false
                  },
                  {
                    id: '17',
                    code: '17',
                    name: 'Адрес местонахождения',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  },
                  {
                    id: '18',
                    code: '18',
                    name: 'Широта',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовое поле с маской ***,******',
                    public: false
                  },
                  {
                    id: '19',
                    code: '19',
                    name: 'Долгота',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовое поле с маской ***,******',
                    public: false
                  },
                  {
                    id: '20',
                    code: '20',
                    name: 'География ритейлера',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '21',
                    code: '21',
                    name: 'Код ФИАС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '22',
                    code: '22',
                    name: 'Уровень по ФИАС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  }
                ]
              },
              {
                id: '4',
                name: 'Торговые параметры',
                elements: [
                  {
                    id: '23',
                    code: '23',
                    name: 'Формат по каналу',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '24',
                    code: '24',
                    name: 'Формат по площади',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '25',
                    code: '25',
                    name: 'Торговая площадь',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '26',
                    code: '26',
                    name: 'Трафик',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '27',
                    code: '27',
                    name: 'Режим работы',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '28',
                    code: '28',
                    name: 'Список представленных категорий',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '29',
                    code: '29',
                    name: 'Длина полок в каждой категории',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '30',
                    code: '30',
                    name: 'Планограмма выкладки',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '31',
                    code: '31',
                    name: 'Ассортиментная емкость',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '32',
                    code: '32',
                    name: 'Количество касс',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  }
                ]
              }
            ],

          }
        ]
      },
      {
        id: '14',
        partyId: '1002',
        schemaId: '1',
        isActual: false,
        name: 'Схема атрибутов 14-05',
        type: 'nomenclature',
        version: '1',
        dateCreate: new Date(),
        dateUpdate:  moment('20200514','YYYYMMDD').toDate(),
        elementsCount: 10,
        pages: [
          {
            id: '0',
            name: 'Лист 1',
            groups: [
              {
                id: '1',
                name: 'Юридическое лицо',
                elements: [
                  {
                    id: '1',
                    code: '1',
                    name: 'Название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '2',
                    code: '2',
                    name: 'Краткое название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '3',
                    code: '3',
                    name: 'ОГРН/ОГРНИП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13-15 цифр',
                    public: false
                  },
                  {
                    id: '4',
                    code: '4',
                    name: 'ИНН',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '5',
                    code: '5',
                    name: 'КПП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '6',
                    code: '6',
                    name: 'Юр. адрес',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  }
                ]
              },
              {
                id: '2',
                name: 'Идентификаторы',
                elements: [
                  {
                    id: '7',
                    code: '7',
                    name: 'Внутрениий номер магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Маска: "Магазин №…" если применимо',
                    public: false
                  },
                  {
                    id: '8',
                    code: '8',
                    name: 'Внутреннее имя магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '9',
                    code: '9',
                    name: 'GLN магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '10',
                    code: '10',
                    name: 'GLN РЦ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '11',
                    code: '11',
                    name: 'GUID (Меркурий)',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '12',
                    code: '12',
                    name: 'ЕГАИС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, до 9-11 цифр',
                    public: false
                  },
                  {
                    id: '13',
                    code: '13',
                    name: 'Логистический филиал',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '14',
                    code: '14',
                    name: 'Единый сквозной идентификатор',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                ]
              }
            ],
          }
        ]
      }
    ]
  },
  {
    current: {
      id: '18',
      partyId: '1003',
      schemaId: '1',
      isActual: true,
      name: 'Текущая схема атрибутов сайтов',
      type: 'nomenclature',
      version: '2',
      dateCreate: new Date(),
      dateUpdate: moment('20200518','YYYYMMDD').toDate(),
      elementsCount: 20,
      pages: [
        {
          id: '0',
          name: 'Лист 1',
          groups: [
            {
              id: '1',
              name: 'Юридическое лицо',
              elements: [
                {
                  id: '1',
                  code: '1',
                  name: 'Название ЮЛ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '2',
                  code: '2',
                  name: 'Краткое название ЮЛ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '3',
                  code: '3',
                  name: 'ОГРН/ОГРНИП',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 13-15 цифр',
                  public: false
                },
                {
                  id: '4',
                  code: '4',
                  name: 'ИНН',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                  public: false
                },
                {
                  id: '5',
                  code: '5',
                  name: 'КПП',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                  public: false
                },
                {
                  id: '6',
                  code: '6',
                  name: 'Юр. адрес',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                  public: false
                }
              ]
            },
            {
              id: '2',
              name: 'Идентификаторы',
              elements: [
                {
                  id: '7',
                  code: '7',
                  name: 'Внутрениий номер магазина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Маска: "Магазин №…" если применимо',
                  public: false
                },
                {
                  id: '8',
                  code: '8',
                  name: 'Внутреннее имя магазина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле',
                  public: false
                },
                {
                  id: '9',
                  code: '9',
                  name: 'GLN магазина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 13 цифр',
                  public: false
                },
                {
                  id: '10',
                  code: '10',
                  name: 'GLN РЦ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 13 цифр',
                  public: false
                },
                {
                  id: '11',
                  code: '11',
                  name: 'GUID (Меркурий)',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '12',
                  code: '12',
                  name: 'ЕГАИС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, до 9-11 цифр',
                  public: false
                },
                {
                  id: '13',
                  code: '13',
                  name: 'Логистический филиал',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '14',
                  code: '14',
                  name: 'Единый сквозной идентификатор',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
              ]
            },
            {
              id: '3',
              name: 'География',
              elements: [
                {
                  id: '15',
                  code: '15',
                  name: 'Регион',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Выбор из классификатора ФИАС',
                  public: false
                },
                {
                  id: '16',
                  code: '16',
                  name: 'Населенный пункт',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Выбор из классификатора ФИАС',
                  public: false
                },
                {
                  id: '17',
                  code: '17',
                  name: 'Адрес местонахождения',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                  public: false
                },
                {
                  id: '18',
                  code: '18',
                  name: 'Широта',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовое поле с маской ***,******',
                  public: false
                },
                {
                  id: '19',
                  code: '19',
                  name: 'Долгота',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовое поле с маской ***,******',
                  public: false
                },
                {
                  id: '20',
                  code: '20',
                  name: 'География ритейлера',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '21',
                  code: '21',
                  name: 'Код ФИАС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле',
                  public: false
                },
                {
                  id: '22',
                  code: '22',
                  name: 'Уровень по ФИАС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            },
            {
              id: '4',
              name: 'Торговые параметры',
              elements: [
                {
                  id: '23',
                  code: '23',
                  name: 'Формат по каналу',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '24',
                  code: '24',
                  name: 'Формат по площади',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '25',
                  code: '25',
                  name: 'Торговая площадь',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '26',
                  code: '26',
                  name: 'Трафик',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '27',
                  code: '27',
                  name: 'Режим работы',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '28',
                  code: '28',
                  name: 'Список представленных категорий',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '29',
                  code: '29',
                  name: 'Длина полок в каждой категории',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '30',
                  code: '30',
                  name: 'Планограмма выкладки',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '31',
                  code: '31',
                  name: 'Ассортиментная емкость',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '32',
                  code: '32',
                  name: 'Количество касс',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            },
            {
              id: '5',
              name: 'Статус',
              elements: [
                {
                  id: '33',
                  code: '33',
                  name: 'Текущий статус',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '34',
                  code: '34',
                  name: 'Дата открытия',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '35',
                  code: '35',
                  name: 'Дата открытия заказов',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '36',
                  code: '36',
                  name: 'Дата закрытия',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '37',
                  code: '37',
                  name: 'Расписание реконструкций',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            },
            {
              id: '6',
              name: 'Контактные данные',
              elements: [
                {
                  id: '38',
                  code: '38',
                  name: 'Имя директора',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '39',
                  code: '39',
                  name: 'Телефон',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '40',
                  code: '40',
                  name: 'e-mail',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            },
            {
              id: '7',
              name: 'Логистические параметры',
              elements: [
                {
                  id: '42',
                  code: '42',
                  name: 'Возможность совмещения несколько ттн в одном авто (РЦ)',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '43',
                  code: '43',
                  name: 'Время обслуживания для выгрузки в секундах',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '44',
                  code: '44',
                  name: 'Время обслуживания для приемки в секундах',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '45',
                  code: '45',
                  name: 'Высота рампы на РЦ, м',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '46',
                  code: '46',
                  name: 'Допустимый свес продукции с поддона, см',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '47',
                  code: '47',
                  name: 'Каждая партия на отдельном поддоне',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '48',
                  code: '48',
                  name: 'Каждая партия отдельным слоем на поддоне',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '49',
                  code: '49',
                  name: 'Каждая партия отдельным столбиком на поддоне',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '50',
                  code: '50',
                  name: 'Каждый SKU отдельным слоем',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '51',
                  code: '51',
                  name: 'Каждый SKU отдельным столбиком',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '52',
                  code: '52',
                  name: 'Максимальная высота поддона, м',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '53',
                  code: '53',
                  name: 'Максимальный вес поддона, кг',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '54',
                  code: '54',
                  name: 'Необходимость заказа пропуска в закрытые города',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '55',
                  code: '55',
                  name: 'Необходимость заказа пропуска на движение грузовых авто',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '56',
                  code: '56',
                  name: 'Необходимость упаковочного / информационного листа',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '57',
                  code: '57',
                  name: 'Радиус доставки',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '58',
                  code: '58',
                  name: 'Требования к внешнему виду водителя - обувь',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '59',
                  code: '59',
                  name: 'Требования к внешнему виду водителя - одежда',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '60',
                  code: '60',
                  name: 'Требования к внешнему виду водителя - санитарная книжка',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '61',
                  code: '61',
                  name: 'Требования к поддонам - американские поддоны',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '62',
                  code: '62',
                  name: 'Требования к поддонам - синие поддоны',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '63',
                  code: '63',
                  name: 'Требования к транспорту - наличие гидролифта',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                },
                {
                  id: '64',
                  code: '64',
                  name: 'Требования к транспорту - наличие пневподвеса',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: '',
                  public: false
                }
              ]
            }

          ],

        }
      ]
    },
    versions: [
      {
        id: '17',
        partyId: '1003',
        schemaId: '1',
        isActual: false,
        name: 'Схема атрибутов 17-05',
        type: 'nomenclature',
        version: '1',
        dateCreate: new Date(),
        dateUpdate:  moment('20200514','YYYYMMDD').toDate(),
        elementsCount: 10,
        pages: [
          {
            id: '0',
            name: 'Лист 1',
            groups: [
              {
                id: '1',
                name: 'Юридическое лицо',
                elements: [
                  {
                    id: '1',
                    code: '1',
                    name: 'Название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '2',
                    code: '2',
                    name: 'Краткое название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '3',
                    code: '3',
                    name: 'ОГРН/ОГРНИП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13-15 цифр',
                    public: false
                  },
                  {
                    id: '4',
                    code: '4',
                    name: 'ИНН',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '5',
                    code: '5',
                    name: 'КПП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '6',
                    code: '6',
                    name: 'Юр. адрес',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  }
                ]
              },
              {
                id: '2',
                name: 'Идентификаторы',
                elements: [
                  {
                    id: '7',
                    code: '7',
                    name: 'Внутрениий номер магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Маска: "Магазин №…" если применимо',
                    public: false
                  },
                  {
                    id: '8',
                    code: '8',
                    name: 'Внутреннее имя магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '9',
                    code: '9',
                    name: 'GLN магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '10',
                    code: '10',
                    name: 'GLN РЦ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '11',
                    code: '11',
                    name: 'GUID (Меркурий)',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '12',
                    code: '12',
                    name: 'ЕГАИС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, до 9-11 цифр',
                    public: false
                  },
                  {
                    id: '13',
                    code: '13',
                    name: 'Логистический филиал',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '14',
                    code: '14',
                    name: 'Единый сквозной идентификатор',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                ]
              },
              {
                id: '3',
                name: 'География',
                elements: [
                  {
                    id: '15',
                    code: '15',
                    name: 'Регион',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Выбор из классификатора ФИАС',
                    public: false
                  },
                  {
                    id: '16',
                    code: '16',
                    name: 'Населенный пункт',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Выбор из классификатора ФИАС',
                    public: false
                  },
                  {
                    id: '17',
                    code: '17',
                    name: 'Адрес местонахождения',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  },
                  {
                    id: '18',
                    code: '18',
                    name: 'Широта',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовое поле с маской ***,******',
                    public: false
                  },
                  {
                    id: '19',
                    code: '19',
                    name: 'Долгота',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовое поле с маской ***,******',
                    public: false
                  },
                  {
                    id: '20',
                    code: '20',
                    name: 'География ритейлера',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '21',
                    code: '21',
                    name: 'Код ФИАС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '22',
                    code: '22',
                    name: 'Уровень по ФИАС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  }
                ]
              },
              {
                id: '4',
                name: 'Торговые параметры',
                elements: [
                  {
                    id: '23',
                    code: '23',
                    name: 'Формат по каналу',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '24',
                    code: '24',
                    name: 'Формат по площади',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '25',
                    code: '25',
                    name: 'Торговая площадь',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '26',
                    code: '26',
                    name: 'Трафик',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '27',
                    code: '27',
                    name: 'Режим работы',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '28',
                    code: '28',
                    name: 'Список представленных категорий',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '29',
                    code: '29',
                    name: 'Длина полок в каждой категории',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '30',
                    code: '30',
                    name: 'Планограмма выкладки',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '31',
                    code: '31',
                    name: 'Ассортиментная емкость',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '32',
                    code: '32',
                    name: 'Количество касс',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  }
                ]
              }
            ],

          }
        ]
      }
    ]
  },
  {
    current: {
      id: '100613',
      partyId: '1006',
      schemaId: '1',
      isActual: true,
      name: 'Текущая схема атрибутов сайтов',
      type: 'nomenclature',
      version: '3',
      dateCreate: new Date(),
      dateUpdate: moment('20200518','YYYYMMDD').toDate(),
      elementsCount: 20,
      pages: [
        {
          id: '0',
          name: 'Лист 1',
          groups: [
            {
              id: '1',
              name: 'Общая информация об артикуле',
              elements: [
                {
                  id: '1',
                  code: '1',
                  name: 'Код Ашан',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '2',
                  code: '2',
                  name: 'Наименование артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '3',
                  code: '3',
                  name: 'Внутренний код поставщика',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 13-15 цифр',
                  public: false
                },
                {
                  id: '4',
                  code: '4',
                  name: 'Штрихкод',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                  public: false
                },
                {
                  id: '5',
                  code: '5',
                  name: 'Дополнительные штрихкоды',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                  public: false
                },
                {
                  id: '6',
                  code: '6',
                  name: 'Категория',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                  public: false
                },
                {
                  id: '7',
                  code: '7',
                  name: 'Семья',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '8',
                  code: '8',
                  name: 'Базовая скидка',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '9',
                  code: '9',
                  name: 'Ставка НДС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '10',
                  code: '10',
                  name: 'Количество штук в коробе РСВ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '11',
                  code: '11',
                  name: 'ITF-14 / Штрихкод',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '12',
                  code: '12',
                  name: 'Количество штук в групповой упаковке суб-РСВ',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '13',
                  code: '13',
                  name: 'ОКПД',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '14',
                  code: '14',
                  name: 'Страна происхождения',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '15',
                  code: '15',
                  name: 'Единица закупки',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '16',
                  code: '16',
                  name: 'Единица продажи',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '17',
                  code: '17',
                  name: 'Характеристика товара',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '18',
                  code: '18',
                  name: 'Тип товара',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '19',
                  code: '19',
                  name: 'Ашан прод',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '20',
                  code: '20',
                  name: 'Код проекта',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '21',
                  code: '21',
                  name: 'Категория товара (cours du jour)',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '22',
                  code: '22',
                  name: 'Статус артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '23',
                  code: '23',
                  name: 'Код ассортимента',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '2',
              name: 'Размер товара в метрах',
              elements: [
                {
                  id: '24',
                  code: '24',
                  name: 'Высота',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '25',
                  code: '25',
                  name: 'Ширина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '26',
                  code: '26',
                  name: 'Глубина',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '3',
              name: 'Хранение',
              elements: [
                {
                  id: '27',
                  code: '27',
                  name: 'Срок годности в днях',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '28',
                  code: '28',
                  name: 'Температура хранения мин',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '29',
                  code: '29',
                  name: 'Температура хранения макс',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '4',
              name: 'Спиртосодержание',
              elements: [
                {
                  id: '30',
                  code: '30',
                  name: 'Спиртосодержание',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '31',
                  code: '31',
                  name: 'Процент содержания спирта',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '32',
                  code: '32',
                  name: 'Код ВАП',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '33',
                  code: '33',
                  name: 'Объем единицы измерения в литрах',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '34',
                  code: '34',
                  name: 'Мин. цена продажи табака',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '35',
                  code: '35',
                  name: 'Макс. цена продажи табака',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '36',
                  code: '36',
                  name: 'МРЦ алкогольной продукции',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '37',
                  code: '37',
                  name: 'Код ЕГАИС',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '5',
              name: 'Коллекция',
              elements: [
                {
                  id: '38',
                  code: '38',
                  name: 'Номер коллекции',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '39',
                  code: '39',
                  name: 'Активность 1 с',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '40',
                  code: '40',
                  name: 'по',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '41',
                  code: '41',
                  name: 'Активность 2 с',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '42',
                  code: '42',
                  name: 'по',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '43',
                  code: '43',
                  name: 'Активность 3 с',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '44',
                  code: '44',
                  name: 'по',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '45',
                  code: '45',
                  name: 'Активность 4 с',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '46',
                  code: '46',
                  name: 'по',
                  type: 'calendar',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '6',
              name: 'Наименование на ценнике',
              elements: [
                {
                  id: '47',
                  code: '47',
                  name: 'Параметр 1',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '48',
                  code: '48',
                  name: 'Параметр 2',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '49',
                  code: '49',
                  name: 'Параметр 3',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '50',
                  code: '50',
                  name: 'Параметр 4',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '51',
                  code: '51',
                  name: 'Параметр 5',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '52',
                  code: '52',
                  name: 'Параметр 6',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '53',
                  code: '53',
                  name: 'Параметр 7',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '54',
                  code: '54',
                  name: 'Параметр 8',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '55',
                  code: '55',
                  name: 'Параметр 9',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '56',
                  code: '56',
                  name: 'Параметр 10',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '57',
                  code: '57',
                  name: 'Параметр 11',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '58',
                  code: '58',
                  name: 'Параметр 12',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '59',
                  code: '59',
                  name: 'Параметр 13',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '60',
                  code: '60',
                  name: 'Параметр 14',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '61',
                  code: '61',
                  name: 'Параметр 15',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            },
            {
              id: '7',
              name: 'Другие атрибуты',
              elements: [
                {
                  id: '62',
                  code: '62',
                  name: 'Стоимость ввода артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '63',
                  code: '63',
                  name: 'Код закрываемого артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '64',
                  code: '64',
                  name: 'Наименование закрываемого артикула',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '65',
                  code: '65',
                  name: 'Комментарий',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '66',
                  code: '66',
                  name: 'Лот заказываемый',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '67',
                  code: '67',
                  name: 'Штука продаваемый',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                },
                {
                  id: '68',
                  code: '68',
                  name: 'Кол-во штук в лоте',
                  type: 'string',
                  length: 50,
                  showHint: false,
                  hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                  public: false
                }
              ]
            }

          ],

        }
      ]
    },
    versions: [
      {
        id: '100612',
        partyId: '1006',
        schemaId: '1',
        isActual: false,
        name: 'Схема атрибутов 17-05',
        type: 'nomenclature',
        version: '2',
        dateCreate: new Date(),
        dateUpdate:  moment('20200517','YYYYMMDD').toDate(),
        elementsCount: 15,
        pages: [
          {
            id: '0',
            name: 'Лист 1',
            groups: [
              {
                id: '1',
                name: 'Юридическое лицо',
                elements: [
                  {
                    id: '1',
                    code: '1',
                    name: 'Название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '2',
                    code: '2',
                    name: 'Краткое название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '3',
                    code: '3',
                    name: 'ОГРН/ОГРНИП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13-15 цифр',
                    public: false
                  },
                  {
                    id: '4',
                    code: '4',
                    name: 'ИНН',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '5',
                    code: '5',
                    name: 'КПП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '6',
                    code: '6',
                    name: 'Юр. адрес',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  }
                ]
              },
              {
                id: '2',
                name: 'Идентификаторы',
                elements: [
                  {
                    id: '7',
                    code: '7',
                    name: 'Внутрениий номер магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Маска: "Магазин №…" если применимо',
                    public: false
                  },
                  {
                    id: '8',
                    code: '8',
                    name: 'Внутреннее имя магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '9',
                    code: '9',
                    name: 'GLN магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '10',
                    code: '10',
                    name: 'GLN РЦ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '11',
                    code: '11',
                    name: 'GUID (Меркурий)',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '12',
                    code: '12',
                    name: 'ЕГАИС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, до 9-11 цифр',
                    public: false
                  },
                  {
                    id: '13',
                    code: '13',
                    name: 'Логистический филиал',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '14',
                    code: '14',
                    name: 'Единый сквозной идентификатор',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                ]
              },
              {
                id: '3',
                name: 'География',
                elements: [
                  {
                    id: '15',
                    code: '15',
                    name: 'Регион',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Выбор из классификатора ФИАС',
                    public: false
                  },
                  {
                    id: '16',
                    code: '16',
                    name: 'Населенный пункт',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Выбор из классификатора ФИАС',
                    public: false
                  },
                  {
                    id: '17',
                    code: '17',
                    name: 'Адрес местонахождения',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  },
                  {
                    id: '18',
                    code: '18',
                    name: 'Широта',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовое поле с маской ***,******',
                    public: false
                  },
                  {
                    id: '19',
                    code: '19',
                    name: 'Долгота',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовое поле с маской ***,******',
                    public: false
                  },
                  {
                    id: '20',
                    code: '20',
                    name: 'География ритейлера',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '21',
                    code: '21',
                    name: 'Код ФИАС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '22',
                    code: '22',
                    name: 'Уровень по ФИАС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  }
                ]
              },
              {
                id: '4',
                name: 'Торговые параметры',
                elements: [
                  {
                    id: '23',
                    code: '23',
                    name: 'Формат по каналу',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '24',
                    code: '24',
                    name: 'Формат по площади',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '25',
                    code: '25',
                    name: 'Торговая площадь',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '26',
                    code: '26',
                    name: 'Трафик',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '27',
                    code: '27',
                    name: 'Режим работы',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '28',
                    code: '28',
                    name: 'Список представленных категорий',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '29',
                    code: '29',
                    name: 'Длина полок в каждой категории',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '30',
                    code: '30',
                    name: 'Планограмма выкладки',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '31',
                    code: '31',
                    name: 'Ассортиментная емкость',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '32',
                    code: '32',
                    name: 'Количество касс',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  }
                ]
              }
            ],

          }
        ]
      },
      {
        id: '100611',
        partyId: '1006',
        schemaId: '1',
        isActual: false,
        name: 'Схема атрибутов 14-05',
        type: 'nomenclature',
        version: '1',
        dateCreate: new Date(),
        dateUpdate:  moment('20200514','YYYYMMDD').toDate(),
        elementsCount: 10,
        pages: [
          {
            id: '0',
            name: 'Лист 1',
            groups: [
              {
                id: '1',
                name: 'Юридическое лицо',
                elements: [
                  {
                    id: '1',
                    code: '1',
                    name: 'Название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '2',
                    code: '2',
                    name: 'Краткое название ЮЛ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле, "кавычки-елочки" запрещены',
                    public: false
                  },
                  {
                    id: '3',
                    code: '3',
                    name: 'ОГРН/ОГРНИП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13-15 цифр',
                    public: false
                  },
                  {
                    id: '4',
                    code: '4',
                    name: 'ИНН',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 10 для организаций, 12 для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '5',
                    code: '5',
                    name: 'КПП',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 9 цифр, неприменимо для ИП и физических лиц',
                    public: false
                  },
                  {
                    id: '6',
                    code: '6',
                    name: 'Юр. адрес',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'код ФИАС, почтовый индекс (6 знаков), Регион, Район, Город, Населенный пункт, Улица (<-выбор из классификатора), Дом, Корпус, Квартира (<- числовое поле), Комментарий (текстовое поле)',
                    public: false
                  }
                ]
              },
              {
                id: '2',
                name: 'Идентификаторы',
                elements: [
                  {
                    id: '7',
                    code: '7',
                    name: 'Внутрениий номер магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Маска: "Магазин №…" если применимо',
                    public: false
                  },
                  {
                    id: '8',
                    code: '8',
                    name: 'Внутреннее имя магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Текстовое поле',
                    public: false
                  },
                  {
                    id: '9',
                    code: '9',
                    name: 'GLN магазина',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '10',
                    code: '10',
                    name: 'GLN РЦ',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, 13 цифр',
                    public: false
                  },
                  {
                    id: '11',
                    code: '11',
                    name: 'GUID (Меркурий)',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '12',
                    code: '12',
                    name: 'ЕГАИС',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: 'Числовой, до 9-11 цифр',
                    public: false
                  },
                  {
                    id: '13',
                    code: '13',
                    name: 'Логистический филиал',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                  {
                    id: '14',
                    code: '14',
                    name: 'Единый сквозной идентификатор',
                    type: 'string',
                    length: 50,
                    showHint: false,
                    hint: '',
                    public: false
                  },
                ]
              }
            ],
          }
        ]
      }
    ]
  },

];
